import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';
import { ACCOUNT_LOCAL_STORAGE_KEY } from '../interceptors/account.interceptor';
import { SnackbarNotificationService } from '@shared/services/snackbar-notification.service';

export type Account = {
  id: number;
  name: string;
};

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);
  private notificationService = inject(SnackbarNotificationService);

  public currentAccountId = signal<Account['id'] | null>(null);
  public accounts = signal<Account[]>([]);

  constructor() {
    if (this.authService.isAdmin()) {
      this.initCurrentAccount();
      this.loadAccounts();
    }
  }

  private initCurrentAccount(): void {
    const storedAccountId = window.localStorage.getItem(ACCOUNT_LOCAL_STORAGE_KEY);
    const currentAccountId = storedAccountId ? Number(storedAccountId) : this.authService.authData.attachedAccount;
    this.currentAccountId.set(currentAccountId);
  }

  private loadAccounts(): void {
    this.http.get<Account[]>(`${environment.apiUrl}/account`).subscribe({
      next: response => {
        const accountNotExists = !response.find(account => account.id === this.currentAccountId());
        if (accountNotExists) {
          this.setAccount(this.authService.authData.attachedAccount);
          return;
        }
        this.accounts.set(response);
      },
      error: () => this.notificationService.error('ACCOUNTS_FETCH_ERROR')
    });
  }

  public setAccount(accountId: Account['id']): void {
    window.localStorage.setItem(ACCOUNT_LOCAL_STORAGE_KEY, `${accountId}`);
    window.location.href = '/';
  }
}
